/* eslint-disable jsx-a11y/img-redundant-alt */
import React, {useEffect, useState} from "react";
import { Link } from "react-router-dom";
import Breadcrumbs from "components/Breadcrumbs";
import {useNavigate, useLocation, useParams} from "react-router-dom"
import { formatDateHandler2 } from "utils/common";
import { getGradeDetailsById } from "api/services/common";


const GradeDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();

  const [userData, setUserData] = useState({})
  useEffect(()=>{
console.log(location,navigate,params, "LLL")
if(params?.id){
  getGradeDetailsById(params?.id).then(response=>{
    console.log(response, "REEEEEEE")
    setUserData(response.data)
  })
}
  },[params?.id])  
  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle="Others"
            title="Grades"
            subtitle="Grade Details"
            modal="#add_indicator"
            name="Add New"
            showModal={false}
            linkName="/grades"
          />
          <div className="card mb-0">
            <div className="card-body">
              <div className="row">
                <div className="col-md-12">
                  <div className="profile-view">                  
                   
                      <div className="row">                    
                        <div className="col-md-10">
                          <ul className="personal-info">
                            <li>
                              <div className="title">Grade Name:</div>
                              <div className="text">{userData?.grade_name}</div>
                            </li>
                            <li>
                              <div className="title">Code:</div>
                              <div className="text">{userData?.grade_code}</div>
                            </li>
                            <li>
                              <div className="title">Minimum Salary:</div>
                              <div className="text">{userData?.minimum_salary}</div>
                            </li>
                            <li>
                              <div className="title">Maximum Salary:</div>
                              <div className="text">{userData?.maximum_salary}</div>
                            </li>
                            <li>
                              <div className="title">Maximum Bonus:</div>
                              <div className="text">{userData?.maximum_bonus}</div>
                            </li>
                            <li>
                              <div className="title">Leave Benefits:</div>
                              <div className="text">{userData?.leave_benefits}</div>
                            </li>
                            <li>
                              <div className="title">Notice Period:</div>
                              <div className="text">{userData?.notice_period}</div>
                            </li>
                            <li>
                              <div className="title">Probation Period:</div>
                              <div className="text">{userData?.probation_period}</div>
                            </li>
                            <li>
                              <div className="title">Air Ticket Allowed (Employee):</div>
                              <div className="text">
                               
                                     {userData?.employee_air_ticket_allowed === true ? (        
                                       "✅"
                                     ) : (       
                                       "❌"
                                     )}
                                </div>
                            </li>

                            <li>
                              <div className="title">Air Ticket Allowed (Dependent):</div>
                              <div className="text">
                           
                                {userData?.dependent_air_ticket_allowed === true ? (        
                                       "✅"
                                     ) : (       
                                       "❌"
                                     )}
                                </div>
                            </li>
                            <li>
                              <div className="title">Air Ticket Limit (Spouse):</div>
                              <div className="text">{userData?.spouse_air_ticket_limit}</div>
                            </li>

                            <li>
                              <div className="title">Air Ticket Limit (Children):</div>
                              <div className="text">{userData?.children_air_ticket_limit}</div>
                            </li>

                            <li>
                              <div className="title">Flight Ticket Calculation Days:</div>
                              <div className="text">{userData?.flight_ticket_calculation_days} days</div>
                            </li>
                          </ul>
                        </div>

                         
                      </div>
                    
               
                  </div>
                </div>
              </div>
            </div>
          </div>


        </div>
      </div>
    </>
  );
};

export default GradeDetails;
